import { motion } from "framer-motion";
import React from "react";
import { useLanguage } from "../context/LanguageContext";
import avatar from "../assets/avatar.png";

const Hero = () => {
	const { t } = useLanguage();

	return (
		<section
			id="home"
			className="min-h-screen flex items-center py-20 bg-gradient-to-br from-white to-gray-100 dark:from-gray-900 dark:to-gray-800">
			<div className="container mx-auto px-4">
				<div className="flex flex-wrap items-center">
					<motion.div
						initial={{ opacity: 0, x: -50 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8 }}
						className="w-full lg:w-1/2 mb-12 lg:mb-0">
						<h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
							{t("greeting")}{" "}
							<span className="text-blue-600 dark:text-blue-400">
								Julien
							</span>
						</h1>
						<h2 className="text-2xl md:text-3xl font-semibold mb-4 text-gray-700 dark:text-gray-300">
							{t("role")}
						</h2>
						<p className="text-lg mb-8 text-gray-600 dark:text-gray-400 max-w-lg">
							{t("heroDesc")}
						</p>
						<div className="flex flex-wrap gap-4">
							<motion.a
								href="/CV_Julien_Pollart.pdf"
								download
								whileHover={{ scale: 1.05 }}
								whileTap={{ scale: 0.95 }}
								className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg transition-colors duration-300 shadow-lg flex items-center justify-center">
								{t("downloadResume")}
							</motion.a>
							<motion.a
								href="#contact"
								whileHover={{ scale: 1.05 }}
								whileTap={{ scale: 0.95 }}
								className="bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-white px-8 py-3 rounded-lg transition-colors duration-300 shadow-lg flex items-center justify-center">
								{t("contactMe")}
							</motion.a>
							<motion.a
								href="#about"
								whileHover={{ scale: 1.05 }}
								whileTap={{ scale: 0.95 }}
								className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 px-4 py-3 flex items-center justify-center border-2 border-blue-600 dark:border-blue-400 rounded-lg transition-colors duration-300">
								{t("learnMore")}
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="h-5 w-5 ml-2"
									viewBox="0 0 20 20"
									fill="currentColor">
									<path
										fillRule="evenodd"
										d="M10 3a1 1 0 011 1v10.586l3.293-3.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z"
										clipRule="evenodd"
									/>
								</svg>
							</motion.a>
						</div>
					</motion.div>
					<motion.div
						initial={{ opacity: 0, x: 50 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.8 }}
						className="w-full lg:w-1/2 flex justify-center">
						{/* Here you can add your profile image or an illustration */}
						<div className="w-64 h-64 md:w-80 md:h-80 bg-blue-600 dark:bg-blue-500 rounded-full overflow-hidden shadow-2xl">
							{/* Replace with your actual profile image */}
							<img
								src={avatar}
								alt="Avatar"
								className="w-full h-full object-cover"
							/>
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default Hero;
